import { api } from '../../../../../AxiosConfig';

export class ServiceFormPlanoService {
    getHorarios(data: any) {
        return api.post('/horarios/by-plano', data);
    }
}